import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p>
        © 2022 Jakub Tatar
      </p>
    </footer>
  );
};

export default Footer;
